//import { Path } from '../routes'
import * as types from '../constants/Action_types'

const initialState = {
    languages: [],

}

export default function (state = initialState, action) {

    switch (action.type) {

        case types.GET_LANGUAGES:


            return {
                ...state,
                languages: action.payload
            }

        default:
            return state
    }
}

/*

export const home = (user) => {
	//return Path.surveyList()
	if (user.role === 'super_admin')
		return Path.regionsList()
	else
		return Path.regionById(user.region)
}*/
